import React from 'react';

const faqItems = [
  {
    q: 'Do I need to type anything?',
    a: 'No. CONSAI is built for voice-first interactions. You can record sales, add stock, and get insights entirely through speech.',
  },
  {
    q: 'Is there a real free trial?',
    a: 'Yes! We offer a full-featured 14-day free trial so you can see the impact on your business before paying anything.',
  },
  {
    q: 'Does it support Hindi?',
    a: 'Yes, our AI understands mixed Hindi and English (Hinglish), making it perfect for Indian business environments.',
  },
  {
    q: 'Is my data safe?',
    a: 'Absolutely. We use bank-grade 256-bit encryption. Your business data is private, secured, and backed up in real-time.',
  },
];

const FAQ = () => {
  return (
    <section className="py-32 bg-surface-container-lowest" id="faq" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-margin-desktop">
        <h2 className="font-headline-lg text-headline-lg text-primary text-center mb-16">
          Frequently Asked Questions
        </h2>
        <div className="space-y-6">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="executive-border p-6 rounded-xl hover:border-outline transition-colors cursor-pointer group"
              data-testid={`faq-item-${i}`}
            >
              <div className="flex justify-between items-center mb-2">
                <h4 className="font-body-lg font-bold text-primary">{item.q}</h4>
                <span className="material-symbols-outlined text-on-surface-variant group-hover:rotate-180 transition-transform">
                  expand_more
                </span>
              </div>
              <p className="font-body-md text-on-surface-variant">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
